// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import sortingImage from "../../../assets/images/wasteSorting.png"; // Add your image path
// import ScrollToTopButton from "../../ScrollToTopButton";

// const AutomatedWasteSorting = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Automation in Waste Sorting"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Resources" },
//           { label: "Blogs" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Automation in Waste Sorting @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/blog/automation-in-waste-sorting"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Summary Section with Image */}
//           <div className="flex flex-col lg:flex-row gap-8 mb-10">
//             <div className="lg:w-2/3">
//               <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//                 Summary
//               </h4>
//               <p className="text-black mb-4 text-lg">
//                 Automation technologies including robotic arms, AI vision
//                 systems, and advanced separators are revolutionizing waste
//                 sorting with unprecedented speed and accuracy while reducing
//                 manual labor requirements.
//               </p>
//               <p className="text-black text-lg">
//                 These systems enable higher material recovery rates, improved
//                 worker safety, and more sustainable operations that align with
//                 circular economy principles.
//               </p>
//             </div>
//             <div className="lg:w-1/3">
//               <img
//                 src={sortingImage}
//                 alt="Automated waste sorting system"
//                 className="w-full h-auto rounded-lg shadow-lg object-cover"
//               />
//               <p className="text-sm text-gray-500 mt-2 italic">
//                 Modern automated sorting line with robotic arms and optical
//                 sensors
//               </p>
//             </div>
//           </div>

//           {/* Introduction Section */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               Introduction
//             </h4>
//             <div className="grid md:grid-cols-3 gap-6">
//               <div className="md:col-span-2">
//                 <p className="text-black mb-4 text-lg">
//                   The waste management industry is transforming as manual
//                   sorting gives way to automated systems that combine mechanical
//                   separation with AI and advanced sensors for precise material
//                   identification.
//                 </p>
//                 <p className="text-black text-lg">
//                   These systems operate continuously, adapting to complex waste
//                   streams while maintaining high purity levels - overcoming the
//                   limitations of human labor in consistency, speed, and
//                   hazardous material handling.
//                 </p>
//               </div>
//               <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
//                 <h5 className="font-bold text-lg mb-2">Sorting Speed</h5>
//                 <p className="text-gray-700">
//                   Automated systems can process 2-3x more material per hour than
//                   manual sorting lines.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Key Technologies Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-4 text-black">
//               Core Automation Technologies
//             </h5>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
//                   <h6 className="font-semibold text-lg mb-2">
//                     AI Optical Sorters
//                   </h6>
//                   <p className="text-gray-700">
//                     High-speed cameras with machine learning identify materials
//                     by composition, color, and shape at 60+ items per minute.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
//                   <h6 className="font-semibold text-lg mb-2">Robotic Arms</h6>
//                   <p className="text-gray-700">
//                     Advanced grippers and suction systems pick and place
//                     specific items with 95%+ accuracy.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
//                   <h6 className="font-semibold text-lg mb-2">
//                     NIR Spectroscopy
//                   </h6>
//                   <p className="text-gray-700">
//                     Detects material composition at molecular level for precise
//                     polymer separation in plastics.
//                   </p>
//                 </div>
//               </div>
//               <div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
//                   <h6 className="font-semibold text-lg mb-2">
//                     Magnetic Separators
//                   </h6>
//                   <p className="text-gray-700">
//                     Automatically extract ferrous and non-ferrous metals from
//                     mixed streams.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
//                   <h6 className="font-semibold text-lg mb-2">
//                     Air Jet Systems
//                   </h6>
//                   <p className="text-gray-700">
//                     Targeted air bursts divert lightweight materials like films
//                     with millimeter precision.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
//                   <h6 className="font-semibold text-lg mb-2">
//                     Automated Baling
//                   </h6>
//                   <p className="text-gray-700">
//                     Compacts sorted materials into uniform bales for efficient
//                     transport and storage.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Benefits Visual */}
//           <div className="mb-10 bg-gray-50 p-6 rounded-lg">
//             <h5 className="text-xl font-semibold mb-4 text-black text-center">
//               Operational Benefits
//             </h5>
//             <div className="grid md:grid-cols-3 gap-4">
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">3x</div>
//                 <p className="text-gray-700">Higher throughput</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">
//                   95%
//                 </div>
//                 <p className="text-gray-700">Sorting accuracy</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">
//                   70%
//                 </div>
//                 <p className="text-gray-700">Labor cost reduction</p>
//               </div>
//             </div>
//           </div>

//           {/* Future Outlook Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Future Outlook
//             </h5>
//             <div className="flex flex-col md:flex-row gap-6">
//               <div className="md:w-2/3">
//                 <p className="text-black text-lg">
//                   Waste sorting will become increasingly intelligent with
//                   hyperspectral imaging, robotics with tactile feedback, and AI
//                   that learns new material types. As these systems become more
//                   affordable, wider adoption will drive global recycling rates
//                   upward, supporting the transition to a circular economy.
//                 </p>
//               </div>
//               <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
//                 <h6 className="font-semibold text-lg mb-2">Emerging Tech</h6>
//                 <p className="text-gray-700">
//                   Next-gen systems will incorporate digital twins for simulation
//                   and blockchain for material traceability.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Ajeevi's Contribution Section */}
//           <div className="bg-gray-50 p-6 rounded-lg">
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Ajeevi's Automation Solutions
//             </h5>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <p className="text-black mb-4 text-lg">
//                   Ajeevi Technologies develops cutting-edge automation solutions
//                   for waste sorting, from AI vision systems to complete robotic
//                   sorting lines tailored to your specific waste streams.
//                 </p>
//                 <p className="text-black text-lg">
//                   Explore our solutions at{" "}
//                   <a
//                     href="http://www.ajeevi.com"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-[#00D084] hover:underline"
//                   >
//                     www.ajeevi.com
//                   </a>
//                   .
//                 </p>
//               </div>
//               <div>
//                 <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//                   <li>
//                     <strong>Custom AI Sorters:</strong> Tailored for different
//                     waste compositions
//                   </li>
//                   <li>
//                     <strong>Robotic Integration:</strong> Seamless addition to
//                     existing lines
//                   </li>
//                   <li>
//                     <strong>Real-Time Analytics:</strong> Continuous process
//                     optimization
//                   </li>
//                   <li>
//                     <strong>Hybrid Solutions:</strong> Combining automation with
//                     quality control
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AutomatedWasteSorting;


import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import sortingImage from "../../../assets/images/UrbanConnectivity.png"; // Add your image path
import ScrollToTopButton from "../../ScrollToTopButton";

const AutomatedWasteSorting = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Smart Poles as Urban Connectivity Hubs"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Resources" },
          { label: "Blogs" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Smart Poles as Urban Connectivity Hubs @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/blog/automation-in-waste-sorting"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* Summary Section with Image */}
    <div className="flex flex-col lg:flex-row gap-8 mb-10">
      <div className="lg:w-2/3">
        <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
          Summary
        </h4>
        <p className="text-black mb-4 text-lg">
          Smart poles are evolving into multifunctional urban connectivity hubs, integrating 5G small cells, Wi-Fi hotspots, IoT sensors, and edge computing capabilities into streetlight infrastructure.
        </p>
        <p className="text-black text-lg">
          These intelligent nodes form the backbone of smart city networks, enabling high-speed connectivity, real-time data collection, and enhanced urban services while minimizing street clutter.
        </p>
      </div>
      <div className="lg:w-1/3">
        <img
          src={sortingImage}
          alt="Smart pole connectivity hub"
          className="w-full h-auto rounded-lg shadow-lg object-cover"
        />
        <p className="text-sm text-gray-500 mt-2 italic">
          Modern smart pole with integrated communication technologies
        </p>
      </div>
    </div>

    {/* Introduction Section */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        Introduction
      </h4>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <p className="text-black mb-4 text-lg">
            Traditional streetlights are being transformed into sophisticated connectivity platforms that support urban digital transformation. Smart poles combine lighting with communication infrastructure, environmental monitoring, and public services in a single, aesthetically designed unit.
          </p>
          <p className="text-black text-lg">
            These hubs serve as the nervous system of smart cities, providing both connectivity and actionable data while reducing the visual pollution of multiple standalone installations.
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
          <h5 className="font-bold text-lg mb-2">Deployment Impact</h5>
          <p className="text-gray-700">
            Cities using smart pole hubs report 60% faster 5G rollout and 40% reduction in infrastructure costs.
          </p>
        </div>
      </div>
    </div>

    {/* Key Technologies Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-4 text-black">
        Core Connectivity Technologies
      </h5>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
            <h6 className="font-semibold text-lg mb-2">5G Small Cells</h6>
            <p className="text-gray-700">
              High-density millimeter wave nodes enabling ultra-fast mobile connectivity with latency under 10ms.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
            <h6 className="font-semibold text-lg mb-2">Multi-Access Edge Computing</h6>
            <p className="text-gray-700">
              Local data processing reduces latency for time-sensitive applications like autonomous vehicles.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
            <h6 className="font-semibold text-lg mb-2">IoT Sensor Integration</h6>
            <p className="text-gray-700">
              Environmental monitoring, traffic counting, and air quality sensors with unified power and data backhaul.
            </p>
          </div>
        </div>
        <div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
            <h6 className="font-semibold text-lg mb-2">Public Wi-Fi 6</h6>
            <p className="text-gray-700">
              High-capacity wireless access points supporting dense urban user demands.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
            <h6 className="font-semibold text-lg mb-2">Fiber Backhaul</h6>
            <p className="text-gray-700">
              High-bandwidth connections linking poles to central networks and cloud services.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
            <h6 className="font-semibold text-lg mb-2">Smart Lighting</h6>
            <p className="text-gray-700">
              Adaptive LED lighting with remote control and energy optimization capabilities.
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Benefits Visual */}
    <div className="mb-10 bg-gray-50 p-6 rounded-lg">
      <h5 className="text-xl font-semibold mb-4 text-black text-center">
        Urban Benefits
      </h5>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">60%</div>
          <p className="text-gray-700">Faster 5G deployment</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">40%</div>
          <p className="text-gray-700">Infrastructure cost savings</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">100+</div>
          <p className="text-gray-700">IoT devices supported per pole</p>
        </div>
      </div>
    </div>

    {/* Future Outlook Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-3 text-black">
        Future Evolution
      </h5>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="md:w-2/3">
          <p className="text-black text-lg">
            Smart poles will evolve into true urban digital platforms, hosting autonomous vehicle communication, drone charging stations, and augmented reality wayfinding. As edge computing capabilities grow, poles will process more data locally, enabling real-time responses to urban challenges while maintaining privacy and security.
          </p>
        </div>
        <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
          <h6 className="font-semibold text-lg mb-2">Next-Gen Features</h6>
          <p className="text-gray-700">
            Future poles may integrate wireless EV charging and air purification systems.
          </p>
        </div>
      </div>
    </div>

    {/* Ajeevi's Contribution Section */}
    <div className="bg-gray-50 p-6 rounded-lg">
      <h5 className="text-xl font-semibold mb-3 text-black">
        Ajeevi's Smart Pole Solutions
      </h5>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <p className="text-black mb-4 text-lg">
            Ajeevi Technologies designs comprehensive smart pole systems that serve as urban connectivity hubs, combining communication technologies, sensors, and smart lighting in modular, future-ready designs.
          </p>
          <p className="text-black text-lg">
            Discover our smart pole solutions at{" "}
            <a
              href="http://www.ajeevi.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00D084] hover:underline"
            >
              www.ajeevi.com
            </a>
            .
          </p>
        </div>
        <div>
          <ul className="list-disc pl-6 space-y-2 text-lg text-black">
            <li>
              <strong>Modular Designs:</strong> Customizable configurations for different urban needs
            </li>
            <li>
              <strong>Carrier-Grade:</strong> Support for multiple telecom providers
            </li>
            <li>
              <strong>Edge Computing:</strong> Local data processing capabilities
            </li>
            <li>
              <strong>Integrated Management:</strong> Unified control of all pole functions
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  );
};

export default AutomatedWasteSorting;
